import { a as _slicedToArray, _ as _toConsumableArray, l as _inherits, h as _createClass, i as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes, { shape, string, oneOfType, number, bool, arrayOf, oneOf, element, objectOf, func, node, any } from 'prop-types';
import { C as Card } from './Card-003e3c50.js';
import { c as currencyShape } from './PropTypes-e1e509ba.js';
import PropertiesFilterByName from './PropertiesFilterByName.js';
import Checkbox from './Checkbox.js';
import { I as Icon } from './index-11bc5ac3.js';
import Slider from 'rc-slider';
import { a as FormattedNumber } from './index-f48c5efa.js';
import LoadingSpinner from './LoadingSpinner.js';
import { u as usePrevious } from './usePrevious-edd83563.js';
import { I as IntlProvider } from './provider-936ecd10.js';

var portalFiltersFilterItemShape = shape({
  name: string,
  value: oneOfType([number, string]),
  code: string,
  fullCode: string
});
var portalFiltersFilterShape = shape({
  name: string,
  type: string,
  filter: bool,
  code: string,
  expanded: bool,
  items: arrayOf(portalFiltersFilterItemShape)
});
var portalFiltersAutocompleteShape = shape({
  code: string,
  name: string
});
var portalFiltersShape = shape({
  filters: arrayOf(portalFiltersFilterShape),
  autocomplete: arrayOf(portalFiltersAutocompleteShape)
});
var weekDayShape = oneOf(['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']);
var alternativeOffersShape = shape({
  active: bool,
  alternativeCheckinCount: number,
  alternativeCheckinDaysOfWeek: arrayOf(weekDayShape),
  resultExpandedByDefault: bool,
  displayArrivalsWithNoAvail: bool,
  filterAndSearchSetting: oneOf(['defaultOn', 'defaultOff', 'alwaysOn'])
});
var labelsShape = shape({
  title: element,
  searchLabel: element,
  searchInputCategory: objectOf(element),
  searchInputNotFound: func,
  alternativeDatesTitle: element,
  alternativeDatesCheckbox: element,
  priceRange: element,
  countries: element,
  mealPlans: element,
  propertyTypes: element,
  showMore: node,
  showLess: node
});
var filterDataShape = shape({
  countries: arrayOf(string),
  geoRegionId: any,
  // TODO
  minPrice: number,
  maxPrice: number,
  mealPlans: arrayOf(string),
  propertyName: string,
  propertyTypes: arrayOf(string),
  stars: arrayOf(string)

  // CLASSIFICATION-XYZ: arrayOf(string),
});

function PropertiesFiltersSection(props) {
  var title = props.title,
    content = props.content,
    children = props.children,
    className = props.className,
    closedByDefault = props.closedByDefault,
    alwaysOpen = props.alwaysOpen,
    filterId = props.filterId,
    capitalizeTitle = props.capitalizeTitle;
  var _useState = useState(!closedByDefault),
    _useState2 = _slicedToArray(_useState, 2),
    sectionActive = _useState2[0],
    setSectionActive = _useState2[1];
  var propertiesFilterSectionTitle = /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-filter-title ".concat(capitalizeTitle ? 'bf-properties-filter-section-capitalized' : '')
  }, title);
  var propertiesFilterSectionContent = /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-filter-section-content"
  }, content || children);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-filter-section ".concat(className),
    "data-filter-id": filterId
  }, alwaysOpen ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-filter-title-wrapper"
  }, propertiesFilterSectionTitle) : null, propertiesFilterSectionContent) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-filter-title-wrapper is-collapsible ".concat(sectionActive ? 'is-active' : 'is-close'),
    onClick: function onClick() {
      return setSectionActive(!sectionActive);
    }
  }, propertiesFilterSectionTitle, /*#__PURE__*/React__default.createElement(Icon, {
    name: sectionActive ? 'bf-icon-angle-down' : 'bf-icon-angle-up',
    className: "bf-properties-filter-title-caret",
    size: "small"
  })), sectionActive ? propertiesFilterSectionContent : null));
}
PropertiesFiltersSection.defaultProps = {
  content: '',
  children: '',
  className: '',
  filterId: '',
  closedByDefault: false,
  alwaysOpen: false,
  capitalizeTitle: false
};
PropertiesFiltersSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  filterId: PropTypes.string,
  closedByDefault: PropTypes.bool,
  alwaysOpen: PropTypes.bool,
  capitalizeTitle: PropTypes.bool
};

var CheckboxesFilters = function CheckboxesFilters(props) {
  var SHOW_MORE_LIMIT = 5;
  var filter = props.filter,
    checkAllLabel = props.checkAllLabel,
    name = props.name,
    isLoading = props.isLoading,
    data = props.data,
    onFilter = props.onFilter,
    showMoreButton = props.showMoreButton,
    labels = props.labels;
  var _useState = useState(Array.isArray(filter) ? filter : []),
    _useState2 = _slicedToArray(_useState, 2),
    checkedValues = _useState2[0],
    setCheckedValues = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    allFiltersShown = _useState4[0],
    setAllFiltersShown = _useState4[1];
  var handleCheckAll = function handleCheckAll(value, checked) {
    if (checked) {
      setCheckedValues([]);
      if (checkedValues.length) {
        onFilter([]);
      }
    }
  };
  var handleCheck = function handleCheck(value, checked) {
    var currentValues = checked ? [].concat(_toConsumableArray(checkedValues), [value]) : checkedValues.filter(function (val) {
      return val !== value;
    });
    setCheckedValues(_toConsumableArray(currentValues));
    onFilter(currentValues);
  };

  // define upon initialization if the list should appear as expanded
  useEffect(function () {
    if (checkedValues.length) {
      var dataKeys = Array.from(data.keys());
      checkedValues.some(function (val) {
        if (dataKeys.findIndex(function (dataKey) {
          return dataKey === val;
        }) > SHOW_MORE_LIMIT) {
          setAllFiltersShown(true);
          return true;
        }
        return false;
      });
    }
  }, [checkedValues]);
  var renderCheckboxList = function renderCheckboxList() {
    var checkboxList = [];
    var count = 0;
    data.forEach(function (itemName, id) {
      if (count < SHOW_MORE_LIMIT || !showMoreButton || allFiltersShown) {
        var key = "filter_item_".concat(id);
        checkboxList.push(/*#__PURE__*/React__default.createElement(Checkbox, {
          value: id,
          id: "".concat(name, "-").concat(id),
          isChecked: checkedValues.includes(id),
          onCheck: handleCheck,
          label: /*#__PURE__*/React__default.createElement("span", null, itemName),
          disabled: isLoading,
          key: key
        }));
      }
      count++;
    });
    return checkboxList;
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-filters-checkboxes"
  }, !!checkAllLabel && /*#__PURE__*/React__default.createElement(Checkbox, {
    defaultChecked: !checkedValues.length,
    value: "all",
    id: "".concat(name, "-all"),
    onCheck: handleCheckAll,
    label: checkAllLabel,
    disabled: isLoading
  }), renderCheckboxList(), showMoreButton && data.size > SHOW_MORE_LIMIT ? /*#__PURE__*/React__default.createElement("a", {
    className: "show-more-button",
    onClick: function onClick() {
      return setAllFiltersShown(!allFiltersShown);
    }
  }, allFiltersShown ? labels.showLess : labels.showMore) : null);
};
CheckboxesFilters.defaultProps = {
  filter: [],
  checkAllLabel: null,
  showMoreButton: false,
  labels: {
    showMore: 'Show more',
    showLess: 'Show less'
  }
};
CheckboxesFilters.propTypes = {
  filter: PropTypes.arrayOf(PropTypes.string),
  onFilter: PropTypes.func.isRequired,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(Map)]).isRequired,
  name: PropTypes.string.isRequired,
  checkAllLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  isLoading: PropTypes.bool.isRequired,
  showMoreButton: PropTypes.bool,
  labels: PropTypes.shape({
    showMore: PropTypes.node,
    showLess: PropTypes.node
  })
};

var PricesRange = function PricesRange(props) {
  var min = props.min,
    max = props.max,
    valueMin = props.valueMin,
    valueMax = props.valueMax,
    onFilter = props.onFilter,
    currency = props.currency,
    isLoading = props.isLoading,
    currencyDisplay = props.currencyDisplay,
    triggeredBy = props.triggeredBy;
  var minValue = valueMin || min || 0;
  var maxValue = valueMax || max || 0;
  var _useState = useState([minValue, maxValue]),
    _useState2 = _slicedToArray(_useState, 2),
    defaultValue = _useState2[0],
    setDefaultValue = _useState2[1];
  var _useState3 = useState([minValue, maxValue]),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState([0, 0]),
    _useState6 = _slicedToArray(_useState5, 2),
    lastValue = _useState6[0],
    setLastValue = _useState6[1];
  var prevMin = usePrevious(min);
  var prevMax = usePrevious(max);
  var prevValueMin = usePrevious(valueMin);
  var prevValueMax = usePrevious(valueMax);
  useEffect(function () {
    var currentValueIsEmpty = value[0] === 0 && value[1] === 0;
    var isMinMaxDefined = min !== null && max !== null;
    var minMaxHasChanged = min !== prevMin || max !== prevMax;
    var valuesHasChanged = valueMin !== prevValueMin || valueMax !== prevValueMax;
    if (isMinMaxDefined) {
      if (valuesHasChanged) {
        var newMin = valueMin || min;
        var newMax = valueMax || max;
        setDefaultValue([newMin, newMax]);
        setValue([newMin, newMax]);
      } else if (minMaxHasChanged || currentValueIsEmpty) {
        setDefaultValue([min, max]);
        setValue([min, max]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [min, max, prevMin, prevMax, valueMin, prevValueMin, valueMax, prevValueMax]);
  var handleSliderChange = function handleSliderChange(newValue) {
    setValue(newValue);
  };
  var handleAfterChangeEvent = function handleAfterChangeEvent(newValue) {
    var hasChangedValue = lastValue[0] !== newValue[0] || lastValue[1] !== newValue[1];
    if (hasChangedValue) {
      setLastValue(newValue);
      onFilter(newValue[0], newValue[1]);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: "".concat(defaultValue[0], "-").concat(defaultValue[1])
  }, /*#__PURE__*/React__default.createElement(Slider.Range, {
    onChange: handleSliderChange,
    onAfterChange: handleAfterChangeEvent,
    defaultValue: defaultValue,
    min: min || 0,
    max: max || 0,
    allowCross: false,
    disabled: isLoading
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-prices-range-reference-wrapper"
  }, isLoading && triggeredBy !== 'filters' ? /*#__PURE__*/React__default.createElement(LoadingSpinner, {
    size: "tiny"
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormattedNumber, {
    currency: currency,
    currencyDisplay: currencyDisplay,
    value: value[0],
    fractionDigits: 0
  }), ' - ', /*#__PURE__*/React__default.createElement(FormattedNumber, {
    currency: currency,
    currencyDisplay: currencyDisplay,
    value: value[1],
    fractionDigits: 0
  }))));
};
PricesRange.defaultProps = {
  valueMin: 0,
  valueMax: 0,
  min: 0,
  max: 0,
  triggeredBy: ''
};
PricesRange.propTypes = {
  valueMin: PropTypes.number,
  valueMax: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  currency: PropTypes.shape(currencyShape).isRequired,
  currencyDisplay: PropTypes.string.isRequired,
  onFilter: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  triggeredBy: PropTypes.string
};

var PortalFilters = /*#__PURE__*/function (_React$Component) {
  function PortalFilters() {
    var _this;
    _classCallCheck(this, PortalFilters);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PortalFilters, [].concat(args));
    /** @type {PortalFiltersProps} */
    _this.props = void 0;
    return _this;
  }
  _inherits(PortalFilters, _React$Component);
  return _createClass(PortalFilters, [{
    key: "wrapFilter",
    value:
    /**
     * @param {WrapFilterOptions} options
     * @param {JSX.Element} content
     * @returns {JSX.Element}
     */
    function wrapFilter(options, content) {
      var _options$filter = options.filter,
        type = _options$filter.type,
        code = _options$filter.code;
      return /*#__PURE__*/React__default.createElement(PropertiesFiltersSection, {
        className: "bf-properties-filters-section",
        filterId: "".concat(type, "-").concat(code),
        closedByDefault: options.closedByDefault,
        alwaysOpen: options.alwaysOpen,
        title: options.label,
        content: content,
        capitalizeTitle: !!options.capitalizeTitle,
        key: "".concat(type, ":").concat(code)
      });
    }

    /**
     * @param {PortalFiltersResponseFilter} filter
     * @returns {JSX.Element}
     */
  }, {
    key: "renderSearchBar",
    value: function renderSearchBar(filter) {
      var _this$props = this.props,
        labels = _this$props.labels,
        isLoading = _this$props.isLoading,
        onFilterProperties = _this$props.onFilterProperties,
        onChangeSearchInput = _this$props.onChangeSearchInput,
        resetAutocompleteFilters = _this$props.resetAutocompleteFilters,
        setAutocompleteFilter = _this$props.setAutocompleteFilter,
        autocompleteFilterApplied = _this$props.autocompleteFilterApplied,
        onGetPlace = _this$props.onGetPlace;
      return this.wrapFilter({
        filter: filter,
        label: labels.searchLabel || filter.name,
        closedByDefault: false,
        alwaysOpen: true,
        capitalizeTitle: true
      }, /*#__PURE__*/React__default.createElement(PropertiesFilterByName, {
        onFilterProperties: onFilterProperties,
        onChange: onChangeSearchInput,
        resetAutocompleteFilters: resetAutocompleteFilters,
        setAutocompleteFilter: setAutocompleteFilter,
        autocompleteFilterApplied: autocompleteFilterApplied,
        searchInputCategoriesLabels: labels.searchInputCategory,
        searchInputIntlNotFindMessage: labels.searchInputNotFound,
        onGetPlace: onGetPlace,
        isLoading: isLoading
      }));
    }

    /**
     * @param {PortalFiltersResponseFilter} filter
     * @returns {JSX.Element | null}
     */
  }, {
    key: "renderAlternativeDates",
    value: function renderAlternativeDates(filter) {
      var _this$props2 = this.props,
        labels = _this$props2.labels,
        isLoading = _this$props2.isLoading,
        alternativeOffersConfig = _this$props2.alternativeOffersConfig,
        showAlternativeOffers = _this$props2.showAlternativeOffers,
        toggleAlternativeOffers = _this$props2.toggleAlternativeOffers;
      if (!(alternativeOffersConfig === null || alternativeOffersConfig === void 0 ? void 0 : alternativeOffersConfig.active) || (alternativeOffersConfig === null || alternativeOffersConfig === void 0 ? void 0 : alternativeOffersConfig.filterAndSearchSetting) === 'alwaysOn') {
        return null;
      }
      return this.wrapFilter({
        filter: filter,
        label: labels.alternativeDatesTitle || filter.name,
        closedByDefault: !alternativeOffersConfig.resultExpandedByDefault,
        alwaysOpen: false,
        capitalizeTitle: true
      }, /*#__PURE__*/React__default.createElement(Checkbox, {
        onCheck: function onCheck() {
          toggleAlternativeOffers(!showAlternativeOffers);
        },
        defaultChecked: showAlternativeOffers,
        label: labels.alternativeDatesCheckbox,
        disabled: isLoading,
        key: "alternative-dates-checkbox"
      }));
    }

    /**
     * @param {PortalFiltersResponseFilter} filter
     * @returns {JSX.Element}
     */
  }, {
    key: "renderPriceRange",
    value: function renderPriceRange(filter) {
      var _this$props3 = this.props,
        labels = _this$props3.labels,
        isLoading = _this$props3.isLoading,
        filterData = _this$props3.filterData,
        priceRangeMin = _this$props3.priceRangeMin,
        priceRangeMax = _this$props3.priceRangeMax,
        currency = _this$props3.currency,
        currencyDisplay = _this$props3.currencyDisplay,
        onFilterPrice = _this$props3.onFilterPrice;
      return this.wrapFilter({
        filter: filter,
        label: labels.priceRange || filter.name,
        closedByDefault: false,
        alwaysOpen: true,
        capitalizeTitle: true
      }, /*#__PURE__*/React__default.createElement(PricesRange, {
        valueMin: filterData === null || filterData === void 0 ? void 0 : filterData.minPrice,
        valueMax: filterData === null || filterData === void 0 ? void 0 : filterData.maxPrice,
        min: priceRangeMin,
        max: priceRangeMax,
        currency: currency,
        currencyDisplay: currencyDisplay,
        isLoading: isLoading,
        onFilter: onFilterPrice
      }));
    }

    /**
     * @param {PortalFiltersResponseFilter} filter
     * @param {JSX.Element} label
     * @param {keyof PortalFiltersFilterData | 'classification' | 'awards'} filterId
     * @returns {JSX.Element | null}
     */
  }, {
    key: "renderItemList",
    value: function renderItemList(filter, label, filterId) {
      if (!filter.items.length) {
        return null;
      }
      var _this$props4 = this.props,
        filterData = _this$props4.filterData,
        isLoading = _this$props4.isLoading,
        labels = _this$props4.labels,
        onFilterCheckboxes = _this$props4.onFilterCheckboxes;
      var items = new Map(filter.items.map(function (item) {
        if (filter.type === 'awards') {
          return [item.value, item.name];
        }
        return [item.fullCode, item.name];
      }));
      var _onFilter = function onFilter(value) {
        onFilterCheckboxes(filterId, {
          code: filter.code,
          value: value
        });
      };
      var checkboxLabels = {
        showMore: labels.showMore,
        showLess: labels.showLess
      };

      /** @type {string} dataKey */
      var dataKey = filterId;
      if (filter.type === 'classification' || filter.type === 'awards') {
        dataKey = "".concat(filter.type, "-").concat(filter.code);
      }
      return this.wrapFilter({
        filter: filter,
        label: label || filter.name,
        closedByDefault: !filter.expanded,
        alwaysOpen: false,
        capitalizeTitle: filter.type !== 'classification'
      }, /*#__PURE__*/React__default.createElement(CheckboxesFilters, {
        name: filter.code,
        filter: filterData[dataKey],
        data: items,
        isLoading: isLoading,
        onFilter: function onFilter(value) {
          return _onFilter(value);
        },
        showMoreButton: true,
        labels: checkboxLabels
      }));
    }

    /**
     * @param {PortalFiltersResponseFilter} filter
     * @returns {JSX.Element | null}
     */
  }, {
    key: "renderFilter",
    value: function renderFilter(filter) {
      var labels = this.props.labels;
      switch (filter.type) {
        case 'autocomplete':
          return this.renderSearchBar(filter);
        case 'availableDates':
          return this.renderAlternativeDates(filter);
        case 'priceRange':
          return this.renderPriceRange(filter);
        case 'awards':
          return this.renderItemList(filter, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, filter.name), 'awards');
        case 'country':
          return this.renderItemList(filter, labels.countries, 'countries');
        case 'mealPlan':
          return this.renderItemList(filter, labels.mealPlans, 'mealPlans');
        case 'propertyType':
          return this.renderItemList(filter, labels.propertyTypes, 'propertyTypes');
        case 'classification':
          return this.renderItemList(filter, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, filter.name), 'classification');
        default:
          // eslint-disable-next-line no-console
          console.warn('PortalFilters: Passed in unknown filter type', filter.type);
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _portalFilters$filter,
        _this2 = this;
      var _this$props5 = this.props,
        labels = _this$props5.labels,
        language = _this$props5.language,
        portalFilters = _this$props5.portalFilters,
        transparent = _this$props5.transparent;
      if (!(portalFilters === null || portalFilters === void 0 ? void 0 : (_portalFilters$filter = portalFilters.filters) === null || _portalFilters$filter === void 0 ? void 0 : _portalFilters$filter.length)) {
        return null;
      }
      return /*#__PURE__*/React__default.createElement(IntlProvider, {
        locale: language
      }, /*#__PURE__*/React__default.createElement(Card, {
        title: labels.title,
        titleSize: "medium",
        className: "bf-properties-filters-wrapper",
        transparent: transparent
      }, portalFilters.filters.map(function (f) {
        return _this2.renderFilter(f);
      })));
    }
  }]);
}(React__default.Component);
PortalFilters.defaultProps = {
  priceRangeMin: 0,
  priceRangeMax: 0,
  portalFilters: {
    filters: [],
    autocomplete: []
  },
  autocompleteFilterApplied: '',
  alternativeOffersConfig: undefined,
  transparent: false
};
PortalFilters.propTypes = {
  language: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  labels: labelsShape.isRequired,
  filterData: filterDataShape.isRequired,
  portalFilters: portalFiltersShape,
  autocompleteFilterApplied: PropTypes.string,
  onFilterProperties: PropTypes.func.isRequired,
  onChangeSearchInput: PropTypes.func.isRequired,
  resetAutocompleteFilters: PropTypes.func.isRequired,
  setAutocompleteFilter: PropTypes.func.isRequired,
  onGetPlace: PropTypes.func.isRequired,
  alternativeOffersConfig: alternativeOffersShape,
  showAlternativeOffers: PropTypes.bool.isRequired,
  toggleAlternativeOffers: PropTypes.func.isRequired,
  priceRangeMin: PropTypes.number,
  priceRangeMax: PropTypes.number,
  currency: PropTypes.shape(currencyShape).isRequired,
  currencyDisplay: PropTypes.oneOf(['symbol', 'code']).isRequired,
  onFilterPrice: PropTypes.func.isRequired,
  onFilterCheckboxes: PropTypes.func.isRequired,
  transparent: PropTypes.bool
};

export { PortalFilters as P, alternativeOffersShape as a, portalFiltersShape as p };
//# sourceMappingURL=index-8f601c6e.js.map
